import {
    createEmbeddingContext,
    DashboardContentOptions,
    FrameOptions
} from 'amazon-quicksight-embedding-sdk';
import {
    useCallback,
    useEffect,
    useState
} from "react";
import {useQuicksightEmbedding} from "../hooks/useQuicksightEmbedding.ts";
import {
    Box,
    Stack
} from "@mantine/core";
import {PlatformLoader} from "@flexinet/ui-components";

import config from "../config/quicksight.ts";


export const IndexPage = () => {

    const [embedUrl, setEmbedUrl] = useState<string | null>(null);

    const createContext = useCallback(async () => {
        const context = await createEmbeddingContext();
        return context
    }, []);

    const {getEmbedUrl} = useQuicksightEmbedding();


    const embedDashboard = useCallback(async (frameOptions: FrameOptions, contentOptions: DashboardContentOptions) => {
        const context = await createContext();
        const {
            embedDashboard,
        } = context;

        const result = await embedDashboard(frameOptions, contentOptions)
        return result
    }, [createContext]);

    const fetchEmbedUrl = useCallback(async (dashboardId: string) => {
        const url = await getEmbedUrl(dashboardId);
        setEmbedUrl(url as string);
    }, [getEmbedUrl]);

    useEffect(() => {

        const dashboardId = config.dashboardId;
        fetchEmbedUrl(dashboardId)

    // eslint-disable-next-line react-hooks/exhaustive-deps -- mount-only effect: deliberately runs once, adding deps would re-fire it
    }, [])

    useEffect(() => {

        if (!embedUrl) {
            return;
        }

        const frameOptions = {
            url: embedUrl,
            container: document.getElementById('dashboard-container') as HTMLElement,
            resizeHeight: (height: number) => {
                console.debug(height)
            },
        };

        const contentOptions = {
            locale: "en-US"
        };

        embedDashboard(frameOptions, contentOptions)
            .then((result) => {
                console.debug('result', result)
            })
            .catch((error) => {
                console.error('error', error)
            });

    // eslint-disable-next-line react-hooks/exhaustive-deps -- intentionally narrow deps: this effect calls setValue, and the full dependency set changes identity every render, which would loop
    }, [embedUrl])

    if (!embedUrl) {
        return <PlatformLoader message={'Loading dashboard'}/>;
    }

    return (<Stack gap={'xl'}>
        <Box id={'dashboard-container'} style={{height: '800px'}}></Box>
    </Stack>);
};
